query GetInboxThreadCounts($assignees: [ID!]) {
    inboxThreadCounts(assignees: $assignees) {
        sms {
            openCount
            needsReplyCount
            scheduledCount
            snoozedCount
            closedCount
            failedCount
            unassignedCount
            archivedCount
        }
        chat {
            openCount
            needsReplyCount
            closedCount
            unassignedCount
            lastStartedTime
        }
        messenger {
            openCount
            closedCount
            snoozedCount
            unassignedCount
            needsReplyCount
            failedCount
        }
        instagram {
            openCount
            closedCount
            snoozedCount
            unassignedCount
            needsReplyCount
        }
        allChannels {
            openCount
            closedCount
            snoozedCount
            unassignedCount
            needsReplyCount
        }
        whatsapp {
            openCount
            closedCount
            unassignedCount
            needsReplyCount
        }
        email {
            openCount
            closedCount
            unassignedCount
            needsReplyCount
        }
        chatbot {
            openCount
            closedCount
            unidentifiedCount
        }
    }
}
